// 不需要登录的页面
export const whiteListPage = ['/page/login', '/page/resetPassword', '/page/appCasLogin', '/layout/information-detail']
